import request from 'api/request';

export default function missingTicketIndexRoute() {
  return request({ url: '/tickets/missing' });
}
